import React from 'react'
import styled from 'styled-components'

export default function HighchartsLegends() {
    return (
        <LegendsContainer>
            <div className="main-sample">Sample</div>
            <div className="legend-sample">
                <div className="below">
                    <div className="below__icon">
                        <i style={{ color: '#3866B1', marginRight: 8 }} className="fas fa-circle dot-below" />
                    </div>
                    <div className="below__text">Below 15 °C</div>
                </div>
                <div className="limit">
                    <div className="limit__icon">
                        <i style={{ color: '#129A96', marginRight: 8 }} className="fas fa-circle dot-limit" />
                    </div>
                    <div className="limit__text">
                        <p>Limit</p>
                        <p>15-30 °C</p>
                    </div>
                </div>
                <div className="above">
                    <div className="above__icon">
                        <i style={{ color: '#E04787', marginRight: 8 }} className="fas fa-circle dot-above" />
                    </div>
                    <div className="above__text">Above 30 °C</div>
                </div>
            </div>
        </LegendsContainer>
    )
}

const LegendsContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: 61px !important;
    color: #606a80;

    .main-sample {
        text-align: center;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 13px;
        padding-bottom: 12px;
    }

    .legend-sample {
        display: flex;
        flex-direction: row;
        height: 32px;
        justify-content: space-around;
        font-weight: normal;
        font-size: 11px;
        line-height: 13px;

        .below,
        .above {
            display: flex;
            flex-direction: row;
            height: 32px;
            align-items: center;
            justify-content: left;

            &__text {
                width: 29px;
            }
        }

        .limit {
            display: flex;
            flex-direction: row;
            height: 32px;
            align-items: center;
            justify-content: left;
            padding-left: 5px;

            &__text {
                width: 50px;
                p {
                    font-family: Source Sans Pro;
                    color: #606a80;
                    font-weight: normal;
                    font-size: 11px;
                    line-height: 13px;
                    margin: 0;
                }
            }
        }
    }
`
